<template>
    <div class="menu li_none_style" @click="close">
        <!--<div class="menu-line"></div>-->
        <div v-for="item in menuObj" 
            :key="item.id"
            v-scroll-to="item.path"
            class="menu-drop_down">
            <div class="menu-drop_down_text">
                <ul>
                <!--<li class="menu-hover menu-hover-left">
                        <div class="menu-bar-display menu-hover-bar"></div>
                        <div class="menu-bar-display menu-hover-dot"></div>
                    </li>-->
                    <li class="menu-hover-middle">
                        <div class="menu-title-ch">{{ item.ch_text }}</div>
                        <div class="menu-title-en">{{ item.en_text }}</div>
                    </li>
                <!--<li class="menu-hover">
                        <div class="menu-bar-display menu-hover-dot"></div>
                        <div class="menu-bar-display menu-hover-bar"></div>
                    </li>-->
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Menu',
        props: {
            menuObj: {
                type: Array
            },
        },
        data () {
            return { }
        },
        methods: {
            close: function () {
                this.$emit('close');
            }
        },
    }
</script>
